import { useEffect } from 'react';

const CountryCode = ({ onCountryChange }) => {
    useEffect(() => {
        const browserLocale = navigator.language || navigator.languages[0]; 
        const localeToCountry = {
            'en-US': 'US',
            'en-AU': 'AU',
            'en-GB': 'GB',
            'fr-FR': 'FR',
            'de-DE': 'DE',
            'es-ES': 'ES',
            'it-IT': 'IT'
            
        };

        const detectedCountry = localeToCountry[browserLocale] || 'US'; // Default to 'US'
        onCountryChange(detectedCountry); // Pass detected country to parent
    }, [onCountryChange]);

    return null; // Does not render anything
};

export default CountryCode;
